<template>
    <div class="DateTimePickerTimeLine" @dragover.prevent @drop="pickTime($event)" @click="pickTime($event)" @touchmove="pickTime($event)">
        <div class="DateTimePickerTimeLine__marker-container" v-if="time">
            <div draggable="true" class="DateTimePickerTimeLine__marker" :style="{ left: time.position+'%' }">
            </div>
        </div>
        <div class="DateTimePickerTimeLine__body">
            <template>
                <div class="DateTimePickerTimeLine__points">
                    <div class="DateTimePickerTimeLine__point" v-for="time in times" :key="time.date.valueOf()" :style="{ left: time.position+'%' }">
                    </div>
                </div>
            </template>
            <div class="DateTimePickerTimeLine__hours">
                <div class="DateTimePickerTimeLine__hour" v-for="hour in hours" :key="hour">
                    <div class="DateTimePickerTimeLine__hour-tick">
                    </div>
                    <div class="DateTimePickerTimeLine__hour-name" v-once>
                        {{hour}} <span class="DateTimePickerTimeLine__hour-name-minutes">00</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: 'DateTimePickerTimeLine',
        computed: {
            ...mapState({
                hours: s => s.dateTimePicker.hours,
                times: s => s.dateTimePicker.times,
                time: s => s.dateTimePicker.time
            })
        },
        methods: {
            ...mapActions({
                pickTime: 'dateTimePicker/pickTime'
            })
        }
    };
</script>

<style>
    .DateTimePickerTimeLine {
        cursor: pointer;
        width: 100%;
    }

    .DateTimePickerTimeLine__marker-container {
        position: relative;
        height: 28px;
    }

    .DateTimePickerTimeLine__marker {
        width: 22px;
        height: 22px;
        margin-left: -11px;
        position: absolute;
        cursor: e-resize;
        border-radius: 50% 50% 50% 0;
        border: 2px solid #eee;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        background-color: #fff;
        box-shadow: 0px 2px 5px 0 #777;
    }

        .DateTimePickerTimeLine__marker:after {
            content: '';
            width: 10px;
            height: 10px;
            margin: 4px;
            border: 1px solid hsl(217, 100%, 88%);
            background-color: #B2EBF2;
            position: absolute;
            border-radius: 50%;
        }

    .DateTimePickerTimeLine__body {
        border-top: 20px solid #4DD0E1;
    }

    .DateTimePickerTimeLine__points {
        position: relative;
        margin-top: -20px;
        margin-bottom: 20px;
    }

    .DateTimePickerTimeLine__point {
        position: absolute;
        top: 0px;
        left: 10px;
        height: 20px;
        width: 1px;
        background-color: rgba(255,255,255,0.3);
    }


    .DateTimePickerTimeLine__hours {
        display: flex;
        flex-direction: row;
    }

    .DateTimePickerTimeLine__hour {
        width: 4.167%;
    }

    .DateTimePickerTimeLine__hour-tick {
        height: 3px;
        width: 1px;
        background-color: #ccc;
    }

    .DateTimePickerTimeLine__hour-name {
        font-size: 8px;
        overflow: hidden;
        margin-left: -65%;
        text-align: center;
    }

    .DateTimePickerTimeLine__hour-name-minutes {
        vertical-align: top;
        font-size: 5px;
        color: #ccc;
        border-bottom: 1px solid #eee;
    }

    @media (max-width: 599px) {
        .DateTimePickerTimeLine__hour-name {
            margin-left: -100%;
        }

        .DateTimePickerTimeLine__hour-name-minutes {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// DateTimePickerTimeLine.vue?62d79c1d